<template>
    <el-input ref="input" v-if="type === 'input'" v-model="valueCpd" :placeholder="placeholder" :disabled="disabled"></el-input>
    <el-select ref="select" v-else-if="type === 'select'" v-bind="props" v-model="valueCpd" :multiple="multiple" :filterable="filterable" collapse-tags :placeholder="placeholder" :popper-append-to-body="false" :disabled="disabled" @visible-change="visibleChange">
        <el-option
            v-for="item in options"
            :key="item.option_value"
            :label="item.option_name"
            :value="item.option_value">
        </el-option>
    </el-select>
    <el-date-picker
        v-else-if="type === 'dateTimeRange'"
        v-model="valueCpd"
        type="datetimerange"
        :editable="false"
        value-format="yyyy-MM-dd HH:mm"
        format="yyyy-MM-dd HH:mm"
        popper-class="live-time-date-picker"
        :placeholder="placeholder"
        :disabled="disabled"
    >
    </el-date-picker>
    <el-date-picker
        v-else-if="type === 'dateRange'"
        v-model="valueCpd"
        type="daterange"
        :editable="false"
        :clearable="false"
        range-separator="~"
        value-format="yyyy-MM-dd"
        format="yyyy-MM-dd"
        :start-placeholder="placeholder"
        :end-placeholder="placeholder"
        :disabled="disabled"
        :picker-options="pickerOptions"
        @blur="pickerOptions.onBlur">
    </el-date-picker>
    <el-date-picker
        v-else-if="type === 'date'"
        v-model="valueCpd"
        type="date"
        :editable="false"
        value-format="yyyy-MM-dd"
        format="yyyy-MM-dd"
        :placeholder="placeholder"
        :disabled="disabled">
    </el-date-picker>
    <el-date-picker
        v-else-if="type === 'month'"
        v-model="valueCpd"
        type="month"
        :editable="false"
        value-format="yyyy-MM"
        :placeholder="placeholder"
        :disabled="disabled"
    >
    </el-date-picker>
    <el-date-picker
        v-else-if="type === 'monthRange'"
        class="month-range-picker"
        v-model="valueCpd"
        type="monthrange"
        :editable="false"
        :clearable="false"
        value-format="yyyy-MM"
        format="yyyy-MM"
        :placeholder="placeholder"
        :disabled="disabled">
    </el-date-picker>
    <el-cascader
        v-else-if="type === 'cascader'"
        v-model="valueCpd"
        :clearable="true"
        :options="region"
        :props="{label:'name',children:'list',value:'name'}"
        :placeholder="placeholder"
        :disabled="disabled">
    </el-cascader>
    <div class="date-and-time-ranges" v-else-if="type === 'dateAndTimeRanges'">
        <el-date-picker
            v-model="valueCpd.date"
            type="date"
            :editable="false"
            :clearable="false"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            prefix-icon=" "
            :placeholder="placeholder"
            :disabled="disabled">
        </el-date-picker>
        <el-select ref="select" v-model="valueCpd.timesRanges" :multiple="multiple" :filterable="filterable" collapse-tags :popper-append-to-body="false" :placeholder="placeholder" :disabled="disabled" @visible-change="visibleChange">
            <el-option
                v-for="item in options"
                :key="item.option_value"
                :label="item.option_name"
                :value="item.option_value">
            </el-option>
        </el-select>
    </div>
</template>

<script>
import FormItem from './FormItem.js'
export default FormItem
</script>

<style lang="scss" scoped>
@import "./FormItem.scss";
</style>


// WEBPACK FOOTER //
// src/components/FormItem/FormItem.vue